export const environment = {
  production: true,
  /* firebaseconfig :  {
    apiKey: "AIzaSyAdpX6DcWi0Ezhz7XRjFAHATDST_l7FfJA",
    authDomain: "logisticsappsa.firebaseapp.com",
    databaseURL: "https://logisticsappsa.firebaseio.com",
    projectId: "logisticsappsa",
    storageBucket: "logisticsappsa.appspot.com",
    messagingSenderId: "708027128392"
    } */
    firebaseconfig :  {
      apiKey: "AIzaSyDGgfRaJXAdYRqwDnUHqlKclWyRm-U_yxE",
      authDomain: "paarsel-59e80.firebaseapp.com",
      databaseURL: "https://paarsel-59e80.firebaseio.com",
      projectId: "paarsel-59e80",
      storageBucket: "paarsel-59e80.appspot.com",
      messagingSenderId: "1048823346724"
      }
};



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/environments/environment.prod.ts